/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetRewardsReferralsRow } from '../openapi-types.gen.js';
import { type useGetRewardsReferralsArgs, useGetRewardsReferralsSpec } from '../specs/rewards.spec.gen.js';

export type { GetRewardsReferralsRow } from '../openapi-types.gen.js';
export type { useGetRewardsReferralsArgs } from '../specs/rewards.spec.gen.js';


export const useGetRewardsReferrals = createHook(useGetRewardsReferralsSpec);


/**
 * Hover/intent prefetch companion for `useGetRewardsReferrals`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetRewardsReferrals();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetRewardsReferrals = createPrefetchHook(useGetRewardsReferralsSpec);
